import React from 'react';
import { NavLink } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import './menubar.css';
import Logo from './kml.png'

function Menubar(props){
    
    return(
        <>
            <section className={props.dispa?'menubart':'menubarf'}>
            <div>
            <CloseIcon  onClick={props.close} style={{fontSize: '32px'}} className='buttt'/>
           
            </div>
                  <div className='divactiveLink'>
                  <ul className='divactiveLinkul'>
                  <li className='divactiveLinkli'>
                 <NavLink
                  style={({isActive})=>{
                      return{
                          color:isActive?'#005dffdb':'black'
                      }
                  }}
                  className='divactiveLinka' to='/'>Home</NavLink>
             </li>
                  <li className='divactiveLinkli'>
                 <NavLink
                  style={({isActive})=>{
                      return{
                          color:isActive?'#005dffdb':'black'
                      }
                  }}
                  className='divactiveLinka' to='/service'>Service </NavLink>
             </li>
                  <li className='divactiveLinkli'>
                 <NavLink
                  style={({isActive})=>{
                      return{
                          color:isActive?'#005dffdb':'black'
                      }
                  }}
                  className='divactiveLinka' to='/about'> About</NavLink>
             </li>
                  </ul>
                  </div>
                
                <div className='hcreated'>

                <h2 style={{marginRight:'10px'}}>created by  </h2>
                    < a href='https://www.instagram.com/kamal_soni_____/' target='_blank' rel="noreferrer"
                    style={{    marginTop: 'auto'}}>
                <img src={Logo} height='30px' width='30px' /></a>
                </div>
            </section>
        </>
    )
}
export default Menubar;